import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { toStringHDMS } from 'ol/coordinate.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { toLonLat } from 'ol/proj.js';
import { OSM, Vector as VectorSource } from 'ol/source.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Feature } from 'ol';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import Point from 'ol/geom/Point.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { Position } from '../gis.model';
import { SimpleGeometry } from 'ol/geom';

import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'gis-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('container') container: ElementRef | undefined;
  @ViewChild('content') content: ElementRef | undefined;

  @Input()
  set positionInput(p: Position) {
    if (p != null && p.latitud && p.longitud) {
      this._positionInput = p;
      //this.setPosition(this._positionInput);
      this._items.next([p]);
    }
  }
  get positionInput(): Position {
    return this._positionInput;
  }
  @Output() position = new EventEmitter<Position>();

  map: Map | null = null;
  positionFeature: Feature;
  _positionInput: Position;
  subscription: Subscription;
  mapDivId: string;
  myMap: ElementRef;

  private _items = new BehaviorSubject<Position[]>([]);

  today = new Date();

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.mapDivId = `map-comp-${uuidv4()}`;

    this.map = new Map({
      layers: [],
      view: new View({
        projection: 'EPSG:3857',
        center: [-6200000, -3800000],
        zoom: 6,
        maxZoom: 20,
        minZoom: 6,
        extent: [-7000000, -5000000, -5500000, -3000000]
      })
    });

    this.getWMTSIDE();

    this.addDrawLayer();
    this.addSetPosition();
    this._items.subscribe((x) => {
      this.setPosition(this._positionInput);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.map) {
        this.map.setTarget(this.mapDivId);
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getWMTSIDE() {
    // TODO: Esto debería estar como effect la llamada
    const parser = new WMTSCapabilities();
    const headers = new HttpHeaders();
    headers.set('Access-Control-Allow-Headers', '*');
    const request = this.http.get(
      'https://mapas.ide.uy/geoservicios/WMTS/WMTS_Uruguay_IDEuy_Ortofotos',
      { headers: headers, responseType: 'text' }
    );
    this.subscription = request.subscribe((r) => {
      const result = parser.read(r);
      const options = optionsFromCapabilities(result, {
        layer: 'ortofotos:ORTOFOTOS_2019',
        matrixSet: 'EPSG:3857'
      });
      if (options) {
        let IDELayer = new TileLayer({
          opacity: 1,
          source: new WMTS(options),
          zIndex: 0
        });
        this.map?.addLayer(IDELayer);
      }
    });
  }

  addDrawLayer(): void {
    this.positionFeature = new Feature();
    this.positionFeature.setStyle(
      new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: '#c49835'
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 2
          })
        })
      })
    );
    const source = new VectorSource({
      features: [this.positionFeature]
    });

    const vector = new VectorLayer({
      source: source,
      zIndex: 2
    });
    this.map.addLayer(vector);
  }

  addSetPosition() {
    this.map?.on('singleclick', (evt) => {
      const coordinate = evt.coordinate;
      const longlat = toLonLat(coordinate);
      this.positionFeature.setGeometry(
        coordinate ? new Point(coordinate) : null
      );
      const p = {
        latitud: longlat[1],
        longitud: longlat[0]
      };
      this.position.emit(p);
    });
  }

  setPosition(p: Position) {
    if (p && p.latitud && p.longitud) {
      const coordinate = [p.longitud, p.latitud];
      this.positionFeature.setGeometry(
        coordinate
          ? new Point(coordinate).transform('EPSG:4326', 'EPSG:3857')
          : null
      );
      const simpleGeometry = this.positionFeature.getGeometry();
      if (simpleGeometry instanceof SimpleGeometry) {
        this.map.getView().fit(simpleGeometry, { maxZoom: 17, duration: 1500 });
      }
      this.position.emit(p);
    }
  }
}
